
type ImageLayoutProps = {
    images: string[];
    imageWidth?: string; // e.g., "30%", "200px", "10rem"
  };

  export default function ImageLayout({ images = [], imageWidth = "100%" }: ImageLayoutProps) {
    if (!images.length) return null;
  
    return (
      <div>
        <div className="flex justify-between gap-4">
          {images.map((src, index) => (
            <img
              key={index}
              src={src}
              alt={`Image ${index + 1}`}
              style={{marginBottom:"0em", width: imageWidth}}
            />
          ))}
        </div>
      </div>
    );
  }
